import { render } from "./CallStatusPerUserBarChart.vue?vue&type=template&id=4124b34e&ts=true"
import script from "./CallStatusPerUserBarChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./CallStatusPerUserBarChart.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/charts/CallStatusPerUserBarChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4124b34e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4124b34e', __exports__)) {
    api.reload('4124b34e', __exports__)
  }
  
  module.hot.accept("./CallStatusPerUserBarChart.vue?vue&type=template&id=4124b34e&ts=true", () => {
    api.rerender('4124b34e', render)
  })

}


export default __exports__